import { getDadosResumoSimulacao } from 'api/capitalFlow';
import { openSnackbarMain } from 'components/Shared/openSnackbarMain';
import { useEffect, useState } from 'react';

const useSimulacaoBoxHook = ({ buscarSimulacaoResumo, setLiberarBtnProsseguir }) => {
  const [loadingSimulacao, setLoadingSimulacao] = useState(true);
  const [dadosSimulacaoResumo, setDadosSimulacaoResumo] = useState([]);

  useEffect(() => {
    if (buscarSimulacaoResumo > 0) {
      buscaDadosResumoSimulacao();
    }
  }, [buscarSimulacaoResumo]);

  const buscaDadosResumoSimulacao = () => {
    setLoadingSimulacao(true);

    getDadosResumoSimulacao()
      .then(res => {
        setDadosSimulacaoResumo(res.data);
        setLiberarBtnProsseguir(res.data?.QTDTITULOS > 0);
      })
      .catch(() => {
        openSnackbarMain('Ocorreu um erro ao buscar os dados do resumo da simulação', 'error');
        console.error('Erro ao buscar dados do resumo da simulação');
      })
      .finally(() => setLoadingSimulacao(false));
  };

  return {
    loadingSimulacao,
    dadosSimulacaoResumo
  };
};

export default useSimulacaoBoxHook;
